import { TICKER_TAPE_REQUESTS } from '../dataSource';
import type { WidgetSchema } from '../types';

// Category names must match the BE categories the /api/widgets/tickers-by-category
// route + /banner understand.
const CATEGORY_OPTIONS = [
    { value: 'Politics', label: 'Politics' },
    { value: 'Entertainment', label: 'Entertainment' },
    { value: 'Sports', label: 'Sports' },
    { value: 'Sports - MMA', label: 'Sports (MMA)' },
    { value: 'Sports - Baseball', label: 'Sports (Baseball)' },
    { value: 'Elections', label: 'Elections' },
    { value: 'Economics', label: 'Economics' },
    { value: 'Crypto', label: 'Crypto' },
    { value: 'Climate and Weather', label: 'Climate and Weather' },
    { value: 'Financials', label: 'Financials' },
];

export const tickerTape: WidgetSchema = {
    meta: {
        id: 'ticker-tape',
        category: 'tickers',
        categoryTitle: 'Tickers',
        title: 'Ticker Tape',
        description: 'A live, scrolling banner of markets in a category. Works well as a stream / OBS overlay.',
        status: 'live',
    },
    fields: [
        {
            kind: 'category-select',
            key: 'category',
            label: 'Category',
            options: CATEGORY_OPTIONS,
            defaultValue: 'Politics',
        },
        { kind: 'color', key: 'logoColor', label: 'Logo color', defaultValue: '#09bc7f' },
        { kind: 'boolean', key: 'showLogo', label: 'Show Kalshi logo', defaultValue: true },
        {
            kind: 'utm',
            key: 'utm',
            label: 'Marketing (UTM)',
            defaultValue: { utmSource: '', utmCampaign: '', promoCode: '' },
        },
        { kind: 'boolean', key: 'showBorder', label: 'Border', defaultValue: false },
        { kind: 'boolean', key: 'rounded', label: 'Rounded corners', defaultValue: false },
    ],
    preview: { kind: 'banner-loader' },
    embed: { kind: 'banner-loader', fixed: { widgetSize: 'ticker', variant: 'tape' } },
    dataSource: {
        summary: 'The strip is a page of open events; each carries the price and category the ticker renders.',
        requests: TICKER_TAPE_REQUESTS,
        notes: [
            "There is no server-side category filter. Page through with the `cursor` from each response and filter on the event's `category` field.",
            'Politics, Elections, Economics, Entertainment, Sports, Climate and Weather and Financials come back under exactly those category names.',
            'Sports - MMA and Sports - Baseball are Sports events narrowed by tag, and Crypto is not returned as a category at all, so those three options cannot be reproduced by filtering on category alone.',
            'This widget orders by trending, which the public endpoint does not expose, so expect a different order.',
        ],
    },
};
